import React, { useState, useEffect } from 'react';
import { screenshotsApi, usersApi } from '../services/api';

export function ScreenshotsPage() {
  const [screenshots, setScreenshots] = useState<any[]>([]);
  const [users, setUsers] = useState<any[]>([]);
  const [date, setDate] = useState(new Date().toISOString().split('T')[0]);
  const [selectedUser, setSelectedUser] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    usersApi.list().then(setUsers);
  }, []);

  useEffect(() => {
    setLoading(true);
    screenshotsApi.getCompany(date)
      .then(data => {
        const filtered = selectedUser
          ? data.filter((s: any) => s.userId === parseInt(selectedUser))
          : data;
        setScreenshots(filtered);
      })
      .finally(() => setLoading(false));
  }, [date, selectedUser]);

  return (
    <div style={{ padding: '28px 32px' }}>
      <div className="page-header">
        <div>
          <h1 className="page-title">Capturas de pantalla</h1>
          <p className="page-subtitle">{screenshots.length} capturas</p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <select className="input" style={{ width: 180 }} value={selectedUser} onChange={e => setSelectedUser(e.target.value)}>
            <option value="">Todos los empleados</option>
            {users.map(u => <option key={u.id} value={u.id}>{u.name}</option>)}
          </select>
          <input type="date" className="input" style={{ width: 160 }} value={date} onChange={e => setDate(e.target.value)} />
        </div>
      </div>

      {loading ? (
        <div style={{ textAlign: 'center', padding: 40, color: 'var(--text3)' }}>Cargando...</div>
      ) : screenshots.length === 0 ? (
        <div className="card" style={{ textAlign: 'center', padding: 60 }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>🖼️</div>
          <div style={{ color: 'var(--text3)' }}>Sin capturas para este día</div>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: 12 }}>
          {screenshots.map((s: any) => (
            <div key={s.id} className="card" style={{ padding: 0, overflow: 'hidden' }}>
              <div style={{
                height: 120,
                background: 'var(--bg3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: 32,
              }}>
                {s.isBlurred ? '🔵' : '🖼️'}
              </div>
              <div style={{ padding: '10px 12px' }}>
                <div style={{ fontSize: 12, fontWeight: 600 }}>
                  {new Date(s.takenAt).toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' })}
                </div>
                <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 2 }}>
                  {s.appName || '—'} · {s.fileSizeKb || '?'} KB
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
